export const getValidEdgeNodes = <T>(
    edges: Array<{ node?: {} | null } | null>
) =>
    edges
        .map((edge) => edge?.node)
        .filter((node): node is NonNullable<typeof node> => node != null) as T;
